import { inject, Service } from '@angular/core';
import { PagedResponse } from 'app/shared/models/paged-response.model';
import { BasicHttpClientService } from 'app/shared/services/basic-http-client.service';
import { environment } from 'environments/environment';
import { BasicCollectionDTO } from '../../models/common/basic-collection.models';
import { ValidityDateType } from '../../enum/season-reference.enum';

export interface GetAllBasicCollectionsParams {
  skipCount?: number;
  maxResultCount?: number;
  searchString?: string;
  validity?: ValidityDateType;
}

@Service()
export class BasicCollectionService {
  private _httpClient = inject(BasicHttpClientService);
  private baseUrl: string;

  constructor() {
    this.baseUrl = environment.urls.apiUrl.url;
  }

 getAllBasicCollections(
  loaderId: string,
  params: GetAllBasicCollectionsParams = {}
) {
  const queryParams: Record<string, unknown> = {
    sorting: 'externalCollectionId'
  };

  if (params.skipCount != null) {
    queryParams['skipCount'] = params.skipCount;
  }

  if (params.maxResultCount != null) {
    queryParams['maxResultCount'] = params.maxResultCount;
  }

  if (params.searchString) {
    queryParams['searchString'] = params.searchString;
  }

  if (params.validity != null) {
    queryParams['validity'] = params.validity;
  }

  return this._httpClient.get<PagedResponse<BasicCollectionDTO>>(
    this.baseUrl + '/basic-collections',
    { params: queryParams },
    loaderId
  );
}
}
